import React from 'react';
import { EVENT_TYPE } from '../../constants/match';
import GameEventGoal from './GameEvents/GameEventGoal';
import GameEventWarning from './GameEvents/GameEventWarning';
import GameEventStart from './GameEvents/GameEventStart';
import GameEventShot from './GameEvents/GameEventShot';
import GameEventSubstitution from './GameEvents/GameEventSubstitution';
import GameEventPenalty from './GameEvents/GameEventPenalty';
import { isMatchEventPlayable } from '../../utils/matchevents';
import { LEAGUES } from '../../constants/leagues';
import GameEventRedCard from './GameEvents/GameEventRedCard';
import GameEventOffside from './GameEvents/GameEventOffside';

function Timeline({ match }) {
  const matchevents = match?.matchEvents;

  const renderItem = (event) => {
    const { type } = event;
    const isPlayable = isMatchEventPlayable(match, event, false);

    switch (type) {
      case EVENT_TYPE.WARNING:
        return <GameEventWarning event={event} isPlayable={isPlayable} />;
      case EVENT_TYPE.PENALTY:
        return <GameEventRedCard event={event} isPlayable={isPlayable} />;
      case EVENT_TYPE.GOAL:
        return <GameEventGoal event={event} isPlayable={isPlayable} />;
      case EVENT_TYPE.SHOT_ON_TARGET:
      case EVENT_TYPE.SHOT:
        if (match?.configLeagueName === LEAGUES.FUTSAL) {
          return null;
        }
        return <GameEventShot event={event} isPlayable={isPlayable} />;
      case EVENT_TYPE.START:
      case EVENT_TYPE.PERIOD_RESULT:
        return <GameEventStart event={event} isPlayable={isPlayable} />;
      case EVENT_TYPE.SUBSTITUTION:
        return <GameEventSubstitution event={event} isPlayable={false} />;
      case EVENT_TYPE.PENALTY_KICK:
        return <GameEventPenalty event={event} isPlayable={isPlayable} />;
      case EVENT_TYPE.OFFSIDE:
        return <GameEventOffside event={event} isPlayable={isPlayable} />;
      default:
        console.error('Unknown event type', event);
        break;
    }
    return null;
  };

  if (matchevents?.length === 0) {
    return (
      <div className="row justify-content-center">
        <div className="col-12 tabs-column mt-5">
          <div className="col-12 data-container data-container--reverse-gradient py-5 mt-0 text-center text-regular">
            Matchhändelser kommer att visas här i takt med att de rapporteras
            in.
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 tabs-column d-flex px-sm-3 align-items-center mb-2 mb-lg-4 mt-5">
          <h2 className="heading-h6 heading-sm-h3 flex-grow-1">
            matchhändelser
          </h2>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 tabs-column">
          <div className="data-container data-container--reverse-gradient data-container--no-bg-mobile p-4 p-lg-5">
            {matchevents.map((e) => renderItem(e))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Timeline;
